import { indonesianFormat, indonesianMonthFullFormat, indonesianWithTimeFormat } from '@/models/dateformat';
import moment from 'moment';

export function formatDateID(date: Date | string) {
    return moment(date).format(indonesianFormat);
}

export function formatDateTimeID(date: Date | string) {
    return moment(date).format(indonesianWithTimeFormat);
}

export function formatMonthFullID(date: Date | string) {
    moment.locale('id');
    return moment(date).format(indonesianMonthFullFormat);
}